import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Label from "./Label";
import Input from "@client.components/Input";

const InputComponent = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Label term={label} />
      <Input
        value={value}
        placeholder={t(placeholder)}
        onChange={onChange}
        error={error}
        disabled={disabled}
      />
    </>
  );
};

InputComponent.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.array,
  disabled: PropTypes.bool,
};

export default InputComponent;
